<template>
  <div class="case-types-section">
    <!-- 标签与标题 -->
    <div class="header">
      <div class="tag">
        <span class="blink-dot"></span> service_directory --detail
      </div>
      <h2 class="title">Case Types <span class="gradient">We Review</span></h2>
      <p class="subtitle">Every case is reviewed individually. Here's what each of our eight case types typically
        covers.</p>
    </div>

    <!-- 卡片网格 -->
    <div class="grid">
      <div v-for="item in cases" :key="item.num" class="card">
        <!-- 四角的断线边框 -->
        <span class="corner tl"></span>
        <span class="corner tr"></span>
        <span class="corner bl"></span>
        <span class="corner br"></span>

        <!-- 头部：图标与序号 -->
        <div class="card-header">
          <div class="icon-box">
            <span class="icon">{{ item.icon }}</span>
          </div>
          <span class="num">{{ item.num }}</span>
        </div>

        <!-- 标题与描述 -->
        <h3 class="card-title">{{ item.title }}</h3>
        <p class="card-desc">{{ item.desc }}</p>

        <!-- 底部信息 -->
        <div class="footer">
          <div class="check-item">
            <span class="check-icon">✓</span> {{ item.checkText }}
          </div>
          <div class="code-text">// {{ item.codeText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseTypes',
  data() {
    return {
      cases: [
        {
          num: '01', icon: '🪙', title: 'Cryptocurrency Investment Scams',
          desc: 'Case review for funds lost to fake investment platforms, fraudulent trading schemes, or unrealistic high-yield.',
          checkText: 'Review of the platform promoter', codeText: 'scam.detect'
        },
        {
          num: '02', icon: '🎣', title: 'Phishing & Impersonation Scams',
          desc: 'Support for cases involving phishing links, fake support agents, or scammers impersonating exchanges, wallets, or...',
          checkText: 'Review of the phishing method used', codeText: 'phishing.detect'
        },
        {
          num: '03', icon: '💳', title: 'Unauthorized Wallet Transactions',
          desc: 'Review of transactions sent from your wallet without authorization, including cases involving a compromised device.',
          checkText: 'Transaction and wallet activity review', codeText: 'wallet.trace'
        },
        {
          num: '04', icon: '🏛️', title: 'Exchange & Account Access Issues',
          desc: 'Help navigating exchange lockouts, verification holds, frozen withdrawals, or disputed access to your account.',
          checkText: 'Review of the exchange dispute', codeText: 'access.recover'
        },
        {
          num: '05', icon: '🖥️', title: 'Fraudulent Crypto Platforms',
          desc: 'Assessment of losses tied to unlicensed or fraudulent crypto trading platforms, fake exchanges, or shell investment apps.',
          checkText: 'Platform and operator review', codeText: 'platform.detect'
        },
        {
          num: '06', icon: '🔗', title: 'Digital-Asset Transfer Disputes',
          desc: 'Documentation and tracing support for disputed, misdirected or mismatched digital-asset transfers between wallets.',
          checkText: 'Transaction history review', codeText: 'transfer.trace'
        },
        {
          num: '07', icon: '📂', title: 'Lost or Compromised Wallet Access',
          desc: 'Guidance for wallets that are lost, locked, or compromised due to device failure, forgotten credentials, or unauthorized...',
          checkText: 'Review of available wallet-recovery', codeText: 'wallet.recover'
        },
        {
          num: '08', icon: '🔍', title: 'Blockchain Transaction Tracing',
          desc: 'Mapping how funds moved on-chain across wallets and platforms to support a case review, report, or investigation.',
          checkText: 'On-chain transaction mapping', codeText: 'chain.trace'
        }
      ]
    };
  }
}
</script>

<style scoped>
/* 深色背景与粒子星星效果模拟 */
.case-types-section {
  background-color: #070b14;
  background-image: radial-gradient(circle at 20% 10%, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    radial-gradient(circle at 80% 30%, rgba(0, 255, 136, 0.2) 1px, transparent 1px),
    radial-gradient(circle at 50% 80%, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 200px 200px, 300px 300px, 400px 400px;
  padding: 80px 5%;
}

.header {
  text-align: center;
  margin-bottom: 60px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #1a4d3e;
  background: #0d1117;
  color: #00ff88;
  font-family: monospace;
  padding: 8px 20px;
  border-radius: 50px;
  margin-bottom: 30px;
  font-size: 0.9rem;
}

.blink-dot {
  width: 8px;
  height: 8px;
  background-color: #00ff88;
  border-radius: 50%;
  display: inline-block;
  animation: blink 1.2s infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.2;
  }
}

.title {
  font-size: 3rem;
  font-weight: 800;
  margin: 0 0 15px;
  color: #ffffff;
}

.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

.subtitle {
  color: #a0b3cc;
  font-size: 1.1rem;
}

/* 网格布局 */
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* 卡片基础样式 */
.card {
  position: relative;
  background: rgba(13, 17, 23, 0.8);
  border-radius: 8px;
  /* 减小内边距和取消固定高度 */
  padding: 20px;
  border: 1px solid transparent;
  /* 占位防止抖动 */
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* 鼠标悬停：淡蓝色边框和阴影 */
.card:hover {
  background: rgba(15, 25, 35, 0.95);
  transform: translateY(-5px);
  border: 1px solid #4fd1c5;
  /* 淡蓝色边框 */
  box-shadow: 0 5px 20px rgba(79, 209, 197, 0.15);
  /* 淡蓝色阴影 */
}

/* 四角断开的淡蓝色折线 */
.corner {
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid #4fd1c5;
  /* 变为淡蓝色 */
  transition: all 0.3s ease;
}

.tl {
  top: -1px;
  left: -1px;
  border-right: none;
  border-bottom: none;
}

.tr {
  top: -1px;
  right: -1px;
  border-left: none;
  border-bottom: none;
}

.bl {
  bottom: -1px;
  left: -1px;
  border-right: none;
  border-top: none;
}

.br {
  bottom: -1px;
  right: -1px;
  border-left: none;
  border-top: none;
}

/* 头部 */
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.icon-box {
  width: 40px;
  height: 40px;
  background: rgba(0, 255, 136, 0.1);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  font-size: 1.5rem;
}

.num {
  color: #a0b3cc;
  font-family: monospace;
  font-size: 1rem;
}

/* 标题与描述（字体调小） */
.card-title {
  font-size: 1.2rem;
  /* 调小 */
  font-weight: 700;
  margin: 0 0 12px;
  line-height: 1.4;
}

.card-desc {
  color: #a0b3cc;
  font-size: 0.9rem;
  /* 调小 */
  line-height: 1.6;
  margin: 0;
  flex: 1;
}

/* 底部内容（间距缩小） */
.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.check-item {
  color: #00ff88;
  font-size: 0.85rem;
  /* 调小 */
  display: flex;
  align-items: center;
  gap: 8px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  border: 1px solid #00ff88;
  border-radius: 50%;
  font-size: 0.6rem;
}

.code-text {
  color: #00ff88;
  font-family: monospace;
  font-size: 0.9rem;
  /* 调小 */
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .card {
    min-height: auto;
  }
}
</style>